import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          pickupPoint: 'Pickup Point',
          destination: 'Destination',
          selectVehicle: 'Select Vehicle',
          distance: 'Distance',
          duration: 'Duration',
          estimatedFare: 'Estimated Fare',
          bookNow: 'Book Now',
        },
      },
      nl: {
        translation: {
          pickupPoint: 'Opstapplaats',
          destination: 'Bestemming',
          selectVehicle: 'Kies Voertuig',
          distance: 'Afstand',
          duration: 'Duur',
          estimatedFare: 'Geschatte Prijs',
          bookNow: 'Nu Boeken',
        },
      },
      fr: {
        translation: {
          pickupPoint: 'Point de départ',
          destination: 'Destination',
          selectVehicle: 'Sélectionner le véhicule',
          distance: 'Distance',
          duration: 'Durée',
          estimatedFare: 'Prix estimé',
          bookNow: 'Réserver',
        },
      },
      de: {
        translation: {
          pickupPoint: 'Abholpunkt',
          destination: 'Ziel',
          selectVehicle: 'Fahrzeug auswählen',
          distance: 'Entfernung',
          duration: 'Dauer',
          estimatedFare: 'Geschätzter Preis',
          bookNow: 'Jetzt buchen',
        },
      },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;